import { useTranslation } from 'react-i18next';
import { TabItem } from '@/common/components/Tabs/TabItem/TabItem';
import { Tabs } from '@/common/components/Tabs/Tabs';
import { InsuranceActivity } from '@/common/containers/Dashboard/Insurance/InsuranceHomePage/InsuranceActivity/InsuranceActivity';
import { InsurancePolicyDetail } from '@/common/containers/Dashboard/Insurance/InsuranceHomePage/InsurancePolicyDetail/InsurancePolicyDetail';
import { IInsurancePolicy } from '@/common/integrations/menhir/employee/insurance/insurance.types';
import { ArrayUtils } from '@coverflex-tech/hypernova-utils';
import { useLocalSearchParams } from 'expo-router';

export type TInsuranceHomeDetailsProps = {
  activePolicy?: IInsurancePolicy;
  upcomingPolicy?: IInsurancePolicy;
  hasMovements?: boolean;
};

export function InsuranceHomeDetails({
  activePolicy,
  upcomingPolicy,
  hasMovements,
}: TInsuranceHomeDetailsProps) {
  const { t } = useTranslation();
  const queryParams = useLocalSearchParams<{ tab?: string }>();

  if (activePolicy) {
    if (hasMovements || upcomingPolicy) {
      return (
        <Tabs
          initialTab={
            upcomingPolicy && queryParams.tab === 'upcoming' ? 1 : undefined
          }
        >
          {[
            <TabItem
              key="current"
              label={t('dashboard.insurance_detail.tabs.policy_details')}
            >
              <InsurancePolicyDetail policy={activePolicy} />
            </TabItem>,
            upcomingPolicy && (
              <TabItem
                key="upcoming"
                label={t(
                  'dashboard.insurance_detail.tabs.upcoming_policy_details'
                )}
              >
                <InsurancePolicyDetail policy={upcomingPolicy} />
              </TabItem>
            ),
            hasMovements && (
              <TabItem
                key="activity"
                label={t('dashboard.insurance_detail.tabs.activity')}
              >
                <InsuranceActivity policyId={activePolicy.id} />
              </TabItem>
            ),
          ].filter(ArrayUtils.removeFalsey)}
        </Tabs>
      );
    }
    return <InsurancePolicyDetail policy={activePolicy} />;
  }

  if (upcomingPolicy) {
    return <InsurancePolicyDetail policy={upcomingPolicy} />;
  }

  return null;
}
